module.exports = __webpack_public_path__ + "static/img/haitian.3481026.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/case/haitian.png
// module id = cWD8
// module chunks = 34